import React from 'react';
import { ZapIcon } from 'lucide-react';
import { images, PRICE } from '../../data/content';
import { CtaButton } from '../CtaButton';
import { OptimizedImage } from '../OptimizedImage';
export function FinalCta() {
  return <section className="relative overflow-hidden bg-brand-950 py-12 text-white lg:py-20" aria-labelledby="final-title" data-id="element-275" data-mp="1no6ookvjssvy">
      <div className="relative mx-auto max-w-5xl px-5" data-id="element-276" data-mp="1sm88j80ssw8h">
        <div className="mx-auto max-w-3xl text-center" data-id="element-277" data-mp="1eo1sz7zpvixm">
          <h2 id="final-title" className="font-display text-[28px] font-extrabold leading-tight tracking-tight sm:text-5xl" data-id="element-278" data-mp="1eqe5v6qmb33t">
            ¿Querés ampliar tus oportunidades o tus <span className="text-sun" data-id="element-279" data-mp="14rf7cgzkgnuj">servicios profesionales?</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-display text-base font-extrabold uppercase leading-snug tracking-tight text-brand-100 sm:text-xl" data-id="element-280" data-mp="19q9prhtmgae4">
            Preparate para incorporar el trabajo con adultos mayores a tu perfil.
          </p>
          <div className="mx-auto mt-6 grid max-w-3xl gap-2.5 text-left sm:grid-cols-2" data-id="element-281" data-mp="34156x8ivgxsi">
            
            
          </div>
          <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-100" data-id="element-282" data-mp="3tfxwh0sjxysh">
            REACTIVA TU CUERPO™ reúne 7 módulos + 5 bonos con ejercicios, planificación, rutinas, actividades, adaptaciones y recursos prácticos.
          </p>
        </div>

        <div className="mx-auto mt-10 grid max-w-4xl items-center gap-6 rounded-[32px] bg-white/5 p-6 ring-1 ring-white/15 sm:p-8 md:grid-cols-2 md:gap-10" data-id="element-283" data-mp="71xy2f9o2xxe">
          <OptimizedImage src={images.mockup} alt="Mockup de Reactiva tu Cuerpo" width={1254} height={1254} className="mx-auto h-auto w-full max-w-[340px]" data-id="element-284" data-mp="3ahlld9i2yeu9" />
          <div className="text-center md:text-left" data-id="element-285" data-mp="3jh8d13l0c6a4">
            <p className="font-display text-sm font-extrabold tracking-[0.18em] text-sun" data-id="element-286" data-mp="3jfovl9nm7p6r">REACTIVA TU CUERPO™</p>
            <p className="mt-2 font-display text-2xl font-extrabold" data-id="element-287" data-mp="13o9ffh7uhm4f">7 módulos + 5 bonos</p>
            <p className="mt-5 font-display text-6xl font-extrabold leading-none tracking-tight" data-id="element-288" data-mp="yqhputuoac3e">{PRICE}</p>
            <p className="mt-3 flex items-center justify-center gap-2 text-sm font-semibold text-brand-100 md:justify-start" data-id="element-289" data-mp="3sipqqzl2fpu2">
              <ZapIcon className="h-4 w-4 text-sun" aria-hidden="true" data-id="element-290" data-mp="5e9sydhjrcj5" />
              Acceso digital inmediato
            </p>
            <div className="mt-6" data-id="element-291" data-mp="admfex4iahl7">
              <CtaButton fullWidth data-id="element-292" data-mp="acl3yrjkvt2y" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}